export enum UserType {
  Host = 1,
  Guest = 2,
  NotifyHost = 3,
}

export enum UserTypeText {
  Host = 'host',
  Guest = 'guest',
  NotifyHost = 'notifyHost',
}
